/* eslint-disable camelcase */
import { toast } from 'react-toastify';
import apiActions from 'store/api/actions';
import { baseApi } from 'store/api/apiRequestBuilder';
import { call, put, takeLatest } from 'typed-redux-saga';
import { validateStatus } from 'utils/validateStatus';

import { login } from '../actions';
import actionTypes from '../actionTypes';
import { disconnectWalletState, updateUserState } from '../reducer';

export function* loginSaga({
  type,
  payload: { address: userAddress, web3Provider, token, provider },
}: ReturnType<typeof login>) {
  yield put(apiActions.request(type));

  try {
    if (!token) {
      const {
        data: { message },
        status,
      } = yield* call(baseApi.getLoginMessage, {
        address: userAddress,
      });
      if (!validateStatus(status)) return;
      const signature = yield* call(web3Provider.eth.personal.sign, message, userAddress, '');
      const {
        data: { access_token },
      } = yield call(baseApi.login, {
        message,
        signature,
      });
      yield put(
        updateUserState({
          address: userAddress,
          key: access_token,
          provider,
        }),
      );
      toast.success(`Wallet connected: ${userAddress.slice(0, 5)}...${userAddress.slice(-5)}`);
    } else {
      yield put(
        updateUserState({
          address: userAddress,
          key: token,
          provider,
        }),
      );
    }
    yield put(apiActions.success(type));
  } catch (err) {
    yield put(apiActions.error(type, err));
    yield put(disconnectWalletState());
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.LOGIN, loginSaga);
}
